import React from 'react';

export default function Automacao() {
  return (
    <section className="flex flex-col md:flex-row items-center justify-between px-8 py-12 bg-gradient-to-r from-purple-200 via-indigo-100 to-white">
      {/* Imagem à esquerda */}
      <div className="md:w-1/2 mb-10 md:mb-0 flex justify-center">
        <div className="relative max-w-sm">
          <img
            src="/images/photo-editor-preview.png" // substitua pelo seu caminho de imagem
            alt="Photo Editor Preview"
            className="rounded-lg shadow-xl"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-purple-400/30 to-transparent rounded-lg" />
        </div>
      </div>

      {/* Texto à direita */}
      <div className="md:w-1/2 text-left">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Simplify photo editing with our <br /> online photo editor
        </h2>
        <p className="text-gray-700 mb-4">
          All the tools you need for professional photo editing at your fingertips.
        </p>
        <p className="text-gray-800 font-semibold mb-4">
          Powerful & easy-to-use:
          <span className="font-normal"> A robust photo editor like Photoshop online but with fewer learning curves.</span>
        </p>
        <p className="text-gray-800 font-semibold mb-4">
          A complete suite of photo editing tools:
          <span className="font-normal">
            {' '}
            From basic adjustments like brightness and contrast to advanced editing
            features like retouching portraits, you can do it all with Fotor.
          </span>
        </p>
        <p className="text-gray-700 mb-6">
          <strong>Edit photos online in bulk:</strong> Edit all your photos at once with the{' '}
          <a href="#" className="underline text-gray-800 hover:text-blue-600">
            batch photo editor
          </a>. Get more done in less time.
        </p>
        <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-md shadow">
          Edit photo for free
        </button>
      </div>
    </section>
  );
}
